import React, { useEffect, useState } from 'react';
import styles from './Footer.module.scss';
import Box from '@/components/UI/box/Box';
import SubLinks from '@/components/layout/footer/subLinks/SubLinks';
import Support from '@/components/layout/footer/support/Support';
import Social from '@/components/layout/footer/social/Social';
import Certificates from '@/components/layout/footer/certificates/Certificates';
import NewsLetter from '@/components/layout/footer/newsLetter/NewsLetter';
import DownloadApp from '@/components/layout/footer/downloadApp/DownloadApp';
import Rights from '@/components/layout/footer/rights/Rights';
import SeoLinks from '@/components/layout/footer/seoLinks/SeoLinks';
import Divider from '@/components/UI/divider/Divider';
import { checkIsAppEnvironment } from '@/helpers/checkEnvironments';
const isApp = checkIsAppEnvironment();
const Footer: React.FC = () => {
  const [show, setShow] = useState<boolean>(true);
  useEffect(() => {
    if (sessionStorage.getItem('show-download-banner')) {
      setShow(false);
    } else {
      setShow(true);
    }
  }, [show]);
  if (isApp) return <Box className={styles['app-container']} />;
  return <Box component={'footer'} className={styles['container']} data-sentry-element="Box" data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
      <Box component={'section'} className={styles['wrapper']} data-sentry-element="Box" data-sentry-source-file="Footer.tsx">
        <Box component={'section'} className={styles['row']} data-sentry-element="Box" data-sentry-source-file="Footer.tsx">
          <SubLinks data-sentry-element="SubLinks" data-sentry-source-file="Footer.tsx" />
          <Support data-sentry-element="Support" data-sentry-source-file="Footer.tsx" />
          {show ? <Social /> : <Box className={styles['row-box']}></Box>}
        </Box>
        <Box component={'section'} className={styles['row']} data-sentry-element="Box" data-sentry-source-file="Footer.tsx">
          <Certificates data-sentry-element="Certificates" data-sentry-source-file="Footer.tsx" />
          <NewsLetter data-sentry-element="NewsLetter" data-sentry-source-file="Footer.tsx" />
          {show ? <DownloadApp /> : <Box className={styles['row-box']}></Box>}
        </Box>
        <Divider data-sentry-element="Divider" data-sentry-source-file="Footer.tsx" />
        <Box component={'section'} data-sentry-element="Box" data-sentry-source-file="Footer.tsx">
          <SeoLinks data-sentry-element="SeoLinks" data-sentry-source-file="Footer.tsx" />
        </Box>
      </Box>
      <br />
      <Divider data-sentry-element="Divider" data-sentry-source-file="Footer.tsx" />
      <Rights data-sentry-element="Rights" data-sentry-source-file="Footer.tsx" />
    </Box>;
};
export default React.memo(Footer);